import { fromJS, Map } from "immutable";
import * as CONST from "actions/action_constants";
import _map from "lodash/map";
import _forEach from "lodash/forEach";

const kioskManager = (state = Map({}), action) => {
  const { kioskManager: kioskManagerPayload } = action;
  const managerConfig = kioskManagerPayload;
  switch (action.type) {
    case CONST.APP_INIT_SUCCESS:
      return state.merge(fromJS(managerConfig || {}));
    case CONST.KIOSK_FETCH_SUCCESS:
    case CONST.KIOSK_FETCH_ERROR:
      return state.set("uptimeCheckTick", Date.now());
    default:
      return state;
  }
};

export default kioskManager;
